import {Observable, of} from 'rxjs';
import {
  DictionaryBaseDto,
  PolicyInquiryCountryDto,
  PolicyInquiryVersionBaseDto,
  PolicyInquiryVersionDto,
} from '../../../bonding_shared/model';
import {DictionaryService} from '../../../bonding_shared/services';
import {map} from 'rxjs/operators';
import {Country} from '../../../bonding_shared/model/dictionary-ids';

export class InquiryCountries {
  static getProductsCountries(
    dictionaryService: DictionaryService,
    inquiry: PolicyInquiryVersionBaseDto
  ): Observable<DictionaryBaseDto[]> {
    return InquiryCountries.getProductsCountriesById(dictionaryService, inquiry.productType.id);
  }

  static getProductsCountriesById(
    dictionaryService: DictionaryService,
    productTypeId: number
  ): Observable<DictionaryBaseDto[]> {
    return dictionaryService
      .getDictionaryEntry('InquiryProductType', productTypeId)
      .pipe(map((v) => v.relatedDictionaries['Country']));
  }

  static existsNonMarketCountry(
    dictionaryService: DictionaryService,
    inquiry: PolicyInquiryVersionDto
  ): Observable<boolean> {
    if (!inquiry || !inquiry.countries) {
      return of(false);
    }
    const inqCountryIds = inquiry.countries.map((c) => c.country.id);
    return InquiryCountries.getProductsCountries(dictionaryService, inquiry).pipe(
      map((pcountries) => inqCountryIds.filter((c) => !pcountries.find((f) => f.id === c)).length > 0)
    );
  }

  static countriesSumPlannedTO(inquiry: PolicyInquiryVersionDto, filterPredicateFn) {
    const ct = inquiry && inquiry.countries;
    if (!ct || ct.length === 0) {
      return 0;
    }
    const isNumber = (value) => typeof value === 'number' && isFinite(value);
    const ctFiltered = ct.filter((v) => isNumber(v.plannedTO)).filter(filterPredicateFn);
    if (ctFiltered.length === 0) {
      return 0;
    }
    return ctFiltered.reduce((previousValue, currentValue) => {
      return previousValue + currentValue.plannedTO;
    }, 0);
  }

  static domesticPredicate = (c: PolicyInquiryCountryDto) => c.plannedTO && c.country && c.country.id === Country.PL;
  static exportPredicate = (c: PolicyInquiryCountryDto) => c.plannedTO && c.country && c.country.id !== Country.PL;
}
